/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @noflow
 */
// import 'core-js';       // ES6 - ES7 features
// import 'whatwg-fetch';  // `window.fetch`

polyfillObjectHasOwn();
polyfillAbortSignalAndController();

function polyfillObjectHasOwn() {
  if (!Object.hasOwn) {
    Object.defineProperty(Object, 'hasOwn', {
      value(object, property) {
        if (object == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }
        // eslint-disable-next-line prefer-object-has-own
        return Object.prototype.hasOwnProperty.call(Object(object), property);
      },
      configurable: true,
      enumerable: false,
      writable: true,
    });
  }
}
function polyfillAbortSignalAndController() {
  if (!window.AbortController) {
    window.AbortSignal = function AbortSignal() {
      const delegate = document.createDocumentFragment();

      this.addEventListener = delegate.addEventListener.bind(delegate);
      this.dispatchEvent = delegate.dispatchEvent.bind(delegate);
      this.removeEventListener = delegate.removeEventListener.bind(delegate);
      this.aborted = false;
    };
    window.AbortController = function AbortController() {
      this.signal = new AbortSignal();
    };
    window.AbortController.prototype.abort = function abort() {
      this.signal.aborted = true;
      this.signal.dispatchEvent(new Event('abort'));
    };
  }
}
